import G1 from "../assets/G1.jpg";
import G2 from "../assets/G2.jpg";
import G3 from "../assets/G3.jpg";
import G4 from "../assets/G4.jpg";
import G5 from "../assets/G5.png";
import G6 from "../assets/G6.jpg";

export const projectList = [
  {
    name: "Artist Hub",
    image: G1,
    skills:
      "Node.js, Express, MongoDB, Ajax, Bcrypt, Validations, Middleware, Session",
  },
  {
    name: "GoDutch",
    image: G2,
    skills:
      "Node.js, Express, MongoDB, Bcrypt, Validations, Middleware, Session",
  },
  {
    name: "Test Harness",
    image: G3,
    skills: "Python, GitHub, CI/CD, OOP",
  },
  {
    name: "Breast Cancer Classifier",
    image: G4,
    skills:
      "C++, Matlab, Machine Learning, Neural Networks, Image Processing, GMM",
  },
  {
    name: "BlogMate",
    image: G5,
    skills: "Node.js, MongoDB, Handlebars, Bcrypt, Validations, CSS, HTML",
  },
  {
    name: "Web Automator - Selenium",
    image: G6,
    skills: "Python, Selenium, Automation, CI/CD, Optimization",
  },
];